interface ResolveInvitationEditorContentArgs {
  isEditorUntouched: boolean;
  selectedEntryId: string | null;
  messageSnapshot: string | null;
  fallbackContent?: string | null;
}

interface ResolveInvitationEditorKeyArgs {
  language?: string | null;
  selectedEntryId: string | null;
}

/**
 * Lexical hydrates from initialContent on mount. When the template picker has
 * selected a library entry, the store snapshot is the source of truth even if
 * the editor is still "untouched" relative to that newly-applied template.
 */
export function resolveInvitationEditorContent({
  isEditorUntouched,
  selectedEntryId,
  messageSnapshot,
  fallbackContent,
}: ResolveInvitationEditorContentArgs): string | null {
  if (selectedEntryId && messageSnapshot !== null) {
    return messageSnapshot;
  }

  if (!isEditorUntouched) {
    return messageSnapshot;
  }

  return fallbackContent ?? messageSnapshot;
}

export function resolveInvitationEditorKey({
  language,
  selectedEntryId,
}: ResolveInvitationEditorKeyArgs): string {
  return `${language ?? 'default'}:${selectedEntryId ?? 'system'}`;
}
